export default {"src":"/_next/static/media/patio-400-hinged.206e84ee.svg","height":1000,"width":1000};